<template lang="pug">
   v-layout.box-tarjeta-beneficiarios-formatter(column)
    v-flex.box-top()
      v-layout(align-center justify-center row fill-height)
        v-flex.box-banda()
          span {{mensajeBanda}}
        v-flex( align-self-end style="text-align:center;margin-bottom:1em")
          v-img
            img(:src="icon")
    v-flex.box-bottom()
      v-layout(column)
        v-flex.box-body-title()
          span {{titulo}}
        v-flex(v-if="link" style="line-height:16px")
          span(style="color: #454A6C;") {{descripcion}}
            b(
              @click="linkMethod"
              style="color: #0855C4;text-decoration: underline;cursor: pointer;"
              ) {{link}}
        v-flex.box-button()
          v-btn()
            span {{mensajeBoton}}
</template>

<script>
export default {
  props: [
    'mensajeBanda',
    'icon',
    'titulo',
    'descripcion',
    'mensajeBoton',
    'link',
    'opcion'
  ],
  methods: {
    linkMethod () {
      this.$emit('linkMethod', this.opcion)
    }
  }
}
</script>

<style scoped>
.box-tarjeta-beneficiarios-formatter {
  background: #ffffff;
  max-height: 250px;
  max-height: 250px;
  max-width: 367px;
  box-shadow: 0px 0px 2px #cecece;
  border-radius: 1em;
}

.box-tarjeta-beneficiarios-formatter .box-top {
  background: #0855C4;
  border-radius: 1em 1em 0em 0em;
  height: 9em;
  position: relative;
}

.box-tarjeta-beneficiarios-formatter .box-top .box-banda {
  position: absolute;
  width: 9.4em;
  max-width: 10em;
  height: 2em;
  background: var(--fuchsia-color);
  border-radius: 5px 0px 0px 5px;
  top: 16px;
  right: 0px;
  display: flex;
  align-items: center;
}

.box-tarjeta-beneficiarios-formatter .box-top .box-banda span {
  font-size: 18px;
  color: #FFFFFF;
  margin-left: 0.6em;
}

.box-tarjeta-beneficiarios-formatter .box-bottom {
  position: relative;
  padding: 0.7em 1em 0em 1.5em;

}

.box-tarjeta-beneficiarios-formatter .box-bottom .box-body-title {}

.box-tarjeta-beneficiarios-formatter .box-bottom .box-body-title span {
  font-size: 18px;
  line-height: 0px;
  color: #0855C4;
  font-family: 'Omnes Medium';
}

.box-tarjeta-beneficiarios-formatter .box-bottom .box-button {
  align-self: end !important;
  margin-top: 1em;
  margin-bottom: 0.6em;
}

.box-tarjeta-beneficiarios-formatter .box-bottom .box-button .v-btn {
  margin: 0;
  box-shadow: 0px 0px;
  border-radius: 1em;
  line-height: 0px;
  background: var(--green-color);
  height: 1.8em;
}

.box-tarjeta-beneficiarios-formatter .box-bottom .box-button span {
  font-size: 16px;
  color: #ffffff;
  text-transform: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/generic/TarjetaBeneficiosDesbloqueado2.vue